import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';

import ClassOutlinedIcon from '@mui/icons-material/ClassOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import Button from '@mui/material/Button';

import classes from './RightSection.module.css';

const RightSection = props => {
  console.log('🚀 ~ RightSection ~ props:', props);
  const { productType, academyName, idProduct } = useParams();

  return (
    <aside className={classes.rightSection}>
      <div className={classes.infoContainer}>
        <figure className={classes.imgStoreBook}>
          <img
            className={classes.img}
            src={props.data.imageUrlBook}
            alt={props.data.productName}
          />
        </figure>
        <p className={classes.price}>
          ${new Intl.NumberFormat('en-US').format(props.data.price)}.
          <sup style={{ fontSize: 11 }}>{props.data.cents}</sup>{' '}
          {props.data.badge}
        </p>
        {props.access ? (
          <Button
            className={classes.btnPay}
            component={Link}
            to={`/book/${props.data.bookKey}`}
          >
            Ir al libro
          </Button>
        ) : (
          <Button
            className={classes.btnPay}
            component="a"
            target="_blnak"
            href={`${process.env.REACT_APP_API_URL_PAGOS}/cart/checkout/${productType}/${academyName}/${idProduct}/${props.data.idProduct}`}
          >
            <ShoppingCartOutlinedIcon className={classes.btnIcon} />{' '}
            Continuar con la compra
          </Button>
        )}

        <ClassOutlinedIcon className={classes.complementaryIcon} />
        <p className={classes.sectionInfo}>
          Libro electrónico para la materia {props.data.subjectName}
        </p>
      </div>
    </aside>
  );
};

RightSection.propTypes = {
  // eslint-disable-next-line react/require-default-props
  data: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  access: PropTypes.bool
};

export default RightSection;
